<section class="minotaure-stack">
  <article class="panel dbw-card dbw-card--xl minotaure-header">
    <div class="panel-heading">
      <div>
        <h4>Minotaure</h4>
        <p>
          Données liées à l'investisseur dans Minotaure / Proxeema.
        </p>
      </div>
    </div>
  </article>

  @if (corrections().length > 0 || anomalies().length > 0) {
    <article class="panel dbw-card dbw-card--xl">
      <div class="panel-heading">
        <div>
          <h4>Problèmes connus</h4>
          <p>
            Lignes remontées par le reporting Minotaure pour cet investisseur.
          </p>
        </div>
      </div>
      @if (corrections().length > 0) {
        <div class="problem-block">
          <div class="subheading">
            <h5>Corrections candidates</h5>
            <oui-tag type="status" size="big" status="to-correct"
              >{{ corrections().length }} ligne(s)</oui-tag
            >
          </div>
          <oui-table class="data-table" [lineSizing]="'dense'">
            <table mat-table [dataSource]="corrections()">
              <ng-container matColumnDef="metadataId"
                ><th mat-header-cell *matHeaderCellDef>Metadata</th>
                <td mat-cell *matCellDef="let row">
                  {{ row.metadataId }}
                </td></ng-container
              >
              <ng-container matColumnDef="detection"
                ><th mat-header-cell *matHeaderCellDef>Détection</th>
                <td mat-cell *matCellDef="let row">
                  <oui-tag type="status" size="big" status="to-correct">{{
                    row.detectionLabel || "Correction"
                  }}</oui-tag>
                </td></ng-container
              >
              <ng-container matColumnDef="details"
                ><th mat-header-cell *matHeaderCellDef>Détails</th>
                <td mat-cell *matCellDef="let row">
                  <div class="content-short">
                    <div>ArianeId: {{ row.arianeId ?? "-" }}</div>
                    <div>AvancementId: {{ row.avancementId }}</div>
                  </div>
                </td></ng-container
              >
              <ng-container matColumnDef="actions"
                ><th mat-header-cell *matHeaderCellDef>Action</th>
                <td mat-cell *matCellDef="let row">
                  <oui-button
                    type="text"
                    color="secondary"
                    (click)="openMetadata(row.metadataId)"
                    >Ouvrir</oui-button
                  >
                </td></ng-container
              >
              <tr mat-header-row *matHeaderRowDef="problemColumns"></tr>
              <tr
                mat-row
                *matRowDef="let row; columns: problemColumns"
              ></tr>
            </table>
          </oui-table>
        </div>
      }
      @if (anomalies().length > 0) {
        <div class="problem-block">
          <div class="subheading">
            <h5>Anomalies</h5>
            <oui-tag type="status" size="big" status="error"
              >{{ anomalies().length }} ligne(s)</oui-tag
            >
          </div>
          <oui-table class="data-table" [lineSizing]="'dense'">
            <table mat-table [dataSource]="anomalies()">
              <ng-container matColumnDef="metadataId"
                ><th mat-header-cell *matHeaderCellDef>Metadata</th>
                <td mat-cell *matCellDef="let row">
                  {{ row.metadataId }}
                </td></ng-container
              >
              <ng-container matColumnDef="detection"
                ><th mat-header-cell *matHeaderCellDef>Détection</th>
                <td mat-cell *matCellDef="let row">
                  <oui-tag type="status" size="big" status="error">{{
                    row.detectionLabel || "Anomalie"
                  }}</oui-tag>
                </td></ng-container
              >
              <ng-container matColumnDef="details"
                ><th mat-header-cell *matHeaderCellDef>Détails</th>
                <td mat-cell *matCellDef="let row">
                  <div class="content-short">
                    <dbw-investor-status-tag
                      [statusCode]="row.statusCode"
                    ></dbw-investor-status-tag>
                    <div>AvancementId: {{ row.avancementId }}</div>
                  </div>
                </td></ng-container
              >
              <ng-container matColumnDef="actions"
                ><th mat-header-cell *matHeaderCellDef>Action</th>
                <td mat-cell *matCellDef="let row">
                  <oui-button
                    type="text"
                    color="secondary"
                    (click)="openMetadata(row.metadataId)"
                    >Ouvrir</oui-button
                  >
                </td></ng-container
              >
              <tr mat-header-row *matHeaderRowDef="problemColumns"></tr>
              <tr
                mat-row
                *matRowDef="let row; columns: problemColumns"
              ></tr>
            </table>
          </oui-table>
        </div>
      }
    </article>
  }

  <dbw-investor-viewer-accordion
    anchorId="investor-viewer-minotaure-metadatas"
    accordionTitle="Metadatas liées"
    [itemsCount]="metadatas().length"
    [loading]="loading()">
    @if (loading()) {
      <dbw-state-card appearance="loading" [compact]="true">
        <p>Chargement du contexte Minotaure en cours.</p>
      </dbw-state-card>
    } @else if (error()) {
      <dbw-state-card appearance="error" [compact]="true">
        <p>{{ error() }}</p>
      </dbw-state-card>
    } @else if (metadatas().length === 0) {
      <dbw-state-card appearance="info" [compact]="true">
        <p>Aucune metadata Minotaure liée à cet investisseur.</p>
      </dbw-state-card>
    } @else {
      <div class="metadata-list">
        @for (metadata of metadatas(); track metadata.metadataId) {
          <article class="metadata-card dbw-card dbw-card--md">
            <header class="metadata-card__header">
              <div>
                <h5>Metadata {{ metadata.metadataId }}</h5>
                <p>{{ metadata.workspace.summaryMessage }}</p>
              </div>
              <div class="metadata-card__actions">
                <oui-tag
                  type="status"
                  size="big"
                  [status]="getMetadataBadgeStatus(metadata)"
                  >{{ getMetadataBadgeLabel(metadata) }}</oui-tag
                >
                @if (metadata.investorIsAutomaticSuggestion) {
                  <oui-tag type="status" size="big" status="completed"
                    >Suggestion auto</oui-tag
                  >
                }
                @if (metadata.investorCanBeDeleted) {
                  <oui-tag type="status" size="big" status="todo"
                    >Éligible suppression</oui-tag
                  >
                }
                <oui-button
                  type="outlined"
                  color="secondary"
                  (click)="openMetadata(metadata.metadataId)"
                  >Ouvrir la metadata</oui-button
                >
              </div>
            </header>

            @if (getMetadataInvestorRow(metadata); as investorRow) {
              <section class="metadata-focus dbw-card dbw-card--md">
                <div class="metadata-focus__status">
                  <dbw-investor-status-tag
                    [statusCode]="investorRow.statusCode"
                  ></dbw-investor-status-tag>
                </div>
                <dbw-investor-details
                  [investorId]="investorRow.investorId"
                  [displayName]="investorRow.displayName"
                  [investorCode]="investorRow.investorCode"
                  [atlasPersonnePhysiqueIds]="investorRow.atlasPersonnePhysiqueIds"
                  [showPersonIdsWhen]="'always'"
                  [details]="['Ariane ' + (investorRow.arianeId ?? '-')]"
                ></dbw-investor-details>
              </section>
            }

            @if (getDuplicateGroup(metadata); as duplicateGroup) {
              <section class="analysis-banner dbw-card dbw-card--md">
                <div>
                  <strong
                    >{{ duplicateGroup.matchLabel }} :
                    {{ duplicateGroup.matchValue }}</strong
                  >
                  <p>
                    {{
                      duplicateGroup.requiresManualVerification
                        ? "Vérification manuelle requise pour ce groupe."
                        : "Le groupe est suffisamment discriminant pour une suggestion automatique."
                    }}
                  </p>
                </div>
                @if (metadata.investorSuggestion; as suggestion) {
                  <div class="analysis-score">
                    <strong>{{ suggestion.totalScore }}</strong>
                    <span>{{ suggestion.evaluations.length }} règle(s)</span>
                  </div>
                }
              </section>
            }

            @if (metadata.workspace.hasInvestorPersonMappingConflicts) {
              <dbw-state-card appearance="error" [compact]="true">
                <p>
                  {{
                    metadata.workspace.investorPersonMappingConflictMessage ||
                      "Cette metadata présente des conflits de mapping Investisseur / PersonnePhysique."
                  }}
                </p>
              </dbw-state-card>
            }

            <oui-table class="data-table" [lineSizing]="'dense'">
              <table mat-table [dataSource]="metadata.workspace.rows">
                <ng-container matColumnDef="investor"
                  ><th mat-header-cell *matHeaderCellDef>Investisseur</th>
                  <td mat-cell *matCellDef="let row">
                    <div class="content-long">
                      <strong>{{
                        row.displayName || "Investisseur sans nom"
                      }}</strong>
                      <div>
                        #{{ row.investorId }} •
                        {{ row.investorCode || "Code inconnu" }}
                      </div>
                      @if (row.atlasPersonnePhysiqueIds.length > 1) {
                        <div>
                          Personnes physiques Atlas:
                          {{
                            formatPersonnePhysiqueIds(
                              row.atlasPersonnePhysiqueIds
                            )
                          }}
                        </div>
                      }
                    </div>
                  </td></ng-container
                >
                <ng-container matColumnDef="consultant"
                  ><th mat-header-cell *matHeaderCellDef>Consultant</th>
                  <td mat-cell *matCellDef="let row">
                    <dbw-consultant-card
                      [id]="row.consultantId"
                      [code]="row.consultantCode || '-'"
                      [name]="row.consultantName || '-'"
                      [statusCode]="row.consultantStatusCode"
                    ></dbw-consultant-card>
                  </td></ng-container
                >
                <ng-container matColumnDef="status"
                  ><th mat-header-cell *matHeaderCellDef>Statut</th>
                  <td mat-cell *matCellDef="let row">
                    <dbw-investor-status-tag
                      [statusCode]="row.statusCode"
                    ></dbw-investor-status-tag>
                  </td></ng-container
                >
                <ng-container matColumnDef="arianeId"
                  ><th mat-header-cell *matHeaderCellDef>ArianeId</th>
                  <td mat-cell *matCellDef="let row">
                    {{ row.arianeId ?? "-" }}
                  </td></ng-container
                >
                <tr mat-header-row *matHeaderRowDef="metadataColumns"></tr>
                <tr
                  mat-row
                  *matRowDef="let row; columns: metadataColumns"
                ></tr>
              </table>
            </oui-table>
          </article>
        }
      </div>
    }
  </dbw-investor-viewer-accordion>
</section>
